import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = async (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions)

export const fetchTaskList = ({
  workspaceId, 
  orchId, 
  // orchSha,
  runLimit = 30,
}) => {
  const bodyObj = {
    workspace_id: workspaceId,
    run_limit: runLimit,
    orch_id: orchId,
    // orch_sha: orchSha,
  };

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(bodyObj)
  };

  return postToApi('v1/api/task/list', fetchOptions)
}

// Wrapper for SWR Fetch Function
export const swrTaskListFetcher = (queryParams) => {
  const [orchId, orchSha, workspaceId, runLimit] = queryParams;

  return fetchTaskList({
    orchId, orchSha, workspaceId, runLimit
  }).then(response => response.json());
}
export default fetchTaskList;
